// @flow

import {
  QUESTION_ADDED,
  QUESTION_UPDATED,
  QUESTION_TYPE_CHANGED,
  QUESTION_DELETED,
} from '../actions/questions';
import { getQuestions } from '../reducers/questions';
import { isQuestionValid } from '../helpers';

/**
 * Intercept question related actions and ensure they are valid otherwise
 * disable form submit related buttons
 */
export default $form => store => next => action => {
  const $warning = $form.find('#invalid-form-icon');
  const $buttons = $form.find('.right.menu.actions button');

  const onValid = () => {
    $buttons.removeClass('disabled');
    $warning.hide();
  };

  const onNotValid = () => {
    $buttons.addClass('disabled');
    $warning.show();
  };

  const checkQuestions = () => {
    const questions = getQuestions(store.getState());

    if (questions.every(isQuestionValid)) {
      onValid();
    } else {
      onNotValid();
    }
  };

  const result = next(action);

  switch (action.type) {
    case QUESTION_ADDED:
      // By default a new question is not valid
      onNotValid();
      break;
    case QUESTION_UPDATED:
    case QUESTION_TYPE_CHANGED:
    case QUESTION_DELETED:
      checkQuestions();
      break;
    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/modules/survey/middlewares/question-validator.js